import {useState} from 'react';

export interface FeedbackFormData {
    "username": string,
    "email": string,
    "message": string
}

export interface FeedbackResult {
    "status": string;
    "body": string;
}

export interface UserFeedbackResponse {
    createFeedback: (FeedbackData: FeedbackFormData) => Promise<any>;
    isLoading: boolean;
    error: string | null;
    data: FeedbackResult | null;
}

const useCreateFeedback = (): UserFeedbackResponse => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [data, setData] = useState<FeedbackResult | null>(null);

    const createFeedback = async (FeedbackData: FeedbackFormData) => {
        setIsLoading(true);
        setError(null);

        try {
            const apiUrl = process.env.REACT_APP_API_BASE || '/api';

            const response = await fetch(`${apiUrl}/feedback/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(FeedbackData),
            });

            if (!response.ok) {
                if (response.status === 401) {
                    throw new Error('Сессия истекла. Пожалуйста, войдите снова.');
                }

                const errorText = await response.text();
                throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
            }

            const result = await response.json();
            setData(result);
            return result;
        } catch (err) {
            const errorMessage = err instanceof Error ? err.message : 'Неизвестная ошибка';
            setError(errorMessage);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return {createFeedback, isLoading, error, data};
};

export default useCreateFeedback;